import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    description: '',
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    mobile: '',
    description: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Real-time validation
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (name === 'name') {
        newErrors.name = value.length < 3 ? 'Name must be at least 3 characters' : '';
      }

      if (name === 'email') {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        newErrors.email = !emailRegex.test(value) ? 'Invalid email address' : '';
      }

      if (name === 'mobile') {
        const mobileRegex = /^[0-9]{10}$/;
        newErrors.mobile = !mobileRegex.test(value) ? 'Mobile number must be 10 digits' : '';
      }

      if (name === 'description') {
        newErrors.description = value.length < 10 ? 'Description must be at least 10 characters' : '';
      }

      return newErrors;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for validation errors before sending
    if (Object.values(errors).some((err) => err) ||
      Object.values(formData).some((field) => field.trim() === '')) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid input',
        text: 'Please fix validation errors before submitting.',
      });
      return;
    }
    console.log('Form Data:', formData);
    try {
      const response = await axios.post(
        'https://kumbhatech.com/sendMail.php', // Replace with your live PHP endpoint
        formData,
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('Response:', response.data);
      if (response.data.message === 'Email sent successfully.') {
        Swal.fire({
          icon: 'success',
          title: 'Message Sent!',
          text: response.data.message,
        });
        // Reset form
        setFormData({
          name: '',
          email: '',
          mobile: '',
          description: '',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: response.data.message || 'Failed to send email.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Submission error',
        text: 'Something went wrong while sending your message.',
      });
      console.error('Submission error:', error);
    }
  };

  useEffect(() => {
    document.title = 'Contact Us | KumbhaaTech Solutions';
    return () => {
      document.title = 'Leading Software Company - KumbhaaTech Solutions';
    };
  }, []);

  return (
    <Fragment>
      <section className="contact-us" id="contact">
        <div className="position-relative">
          <div className="animation-home-about animation-round-bg top-right"></div>
          <div className="animation-home-about animation-round-bg bottom-left"></div>
        </div>
        <div className="container">
          <div className="row">
            <div className="mb-4">
              <Link to="/" className="pointer">
                <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
              </Link>
            </div>
            <div className="col-lg-12">
              <div className="col-md-7 justify-content-center m-auto text-white">
                <h1 className="text-white mb-4">Connect with KumbhaTech</h1>
                <p className="text-white">
                  Whether you have specific questions about our services or are eager to
                  delve into the details of your project, our team is dedicated to providing
                  the support and expertise you need. Reach out to us today to start a
                  conversation about how we can collaborate and achieve your goals.
                </p>
              </div>
              <br />
              <br />
              <div className="form-container">
                <form onSubmit={handleSubmit} className="form" noValidate>
                  <div className="input-group">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className={`input ${errors.name ? 'error' : ''}`}
                      required
                    />
                    <label className={formData.name || errors.name ? 'float' : ''}>Name</label>
                    {errors.name && <span className="error-message">{errors.name}</span>}
                  </div>

                  <div className="input-group">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={`input ${errors.email ? 'error' : ''}`}
                      required
                    />
                    <label className={formData.email || errors.email ? 'float' : ''}>Email</label>
                    {errors.email && <span className="error-message">{errors.email}</span>}
                  </div>

                  <div className="input-group">
                    <input
                      type="text"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      className={`input ${errors.mobile ? 'error' : ''}`}
                      required
                    />
                    <label className={formData.mobile || errors.mobile ? 'float' : ''}>Mobile</label>
                    {errors.mobile && <span className="error-message">{errors.mobile}</span>}
                  </div>

                  <div className="input-group">
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      className={`input ${errors.description ? 'error' : ''}`}
                      required
                      rows="6"
                    />
                    <label className={formData.description || errors.description ? 'float' : ''}>
                      Description
                    </label>
                    {errors.description && <span className="error-message">{errors.description}</span>}
                  </div>

                  <button type="submit" className="submit-btn-ct">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <br />
    </Fragment>
  );
};

export default ContactUs;
